import React from "react";
import HeaderLogin from '../components/HeaderLogin'
import meeting from '../assets/img/meeting.png'
import team from '../assets/img/team.png'
import connectivity from '../assets/img/connectivity.png'



function Login() {
  return (
    <div>
      <HeaderLogin />
      <div className="rgc-style loginStyle">
          <div className="rgc-layer">
            <section>
              <div className="container-fluid rgc-style-content">
                <div className="row justify-content-center">
                  <div className="col-12 col-lg-9">
      
                <div className="row g-4 d-flex justify-content-around align-items-center">

                
                  <div className="col-11 col-sm-9 col-lg-3">
                  <a href='https://meetings.mz-ict.ir/'>
                    <div className='rgc-style-item'>
                    <img src={meeting} alt=''/>
                    <span>
                      سامانه مدیریت جلسات
                    </span>
                    </div>
                    </a>
                  </div>
                

                 
                   <div className="col-11 col-sm-9 col-lg-3">
                   <a href='https://esd.mz-ict.ir/'>
                   <div className='rgc-style-item'>
                  <img src={team} alt='' />
                    <span>
                      سامانه ارتباط مردمی
                    </span>
                    </div>
                    </a>
                   </div>
                
                 
                  <div className="col-11 col-sm-9 col-lg-3">
                  <a href='mz-ict.ir'>
                  <div className='rgc-style-item'>
                  <img src={connectivity} alt='' />
                    <span>
                     بانک اطلاعاتی 
                    </span>
                    </div>
                    </a>
                  </div>
              
                </div>
                </div>
                </div>
              </div>
            </section>
          </div>
        </div>
    </div >
  );
}
export default Login;